import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass, NgFor, NgIf} from '@angular/common';
import {CallParticipantRow} from '../call-participants';

/**
 * A group call's Participants (ITP-E-182-04, shared by ITP-E-182-05): everyone with where they stand — in the call
 * (speaking, muted or reconnecting), being rung, declined, no answer, busy or left — the host marked. The call bar shows it
 * above itself and the video call card in its own footer slot; both build the rows with {@link CallParticipants}, so the
 * two lists always agree.
 *
 * Where it is a panel someone can put away (ITP-E-189-09), the host listens to `(close)` and the header grows a ×, as
 * Meet's side panels have one; a list nobody listens to shows none.
 *
 * ITP-E-198-01: a phone person's row reads "📞 <name>" with the number masked, and has Cancel while dialled, Hang up once in
 * the call — `(hangUpPhone)` with the row's phone key.
 */
@Component({
  selector: 'app-call-participants-list',
  standalone: true,
  imports: [NgIf, NgFor, NgClass],
  templateUrl: './call-participants-list.component.html',
  styleUrls: ['./call-participants-list.component.scss']
})
export class CallParticipantsListComponent {
  @Input({required: true}) rows: CallParticipantRow[] = [];
  /** The group's name, as the list's heading. */
  @Input() title: string | undefined;
  /** The id the toggle that opens it points at (`aria-controls`). */
  @Input() listId: string | undefined;
  /** The × in the header, shown only to a host that listens: the panel is theirs to put away. */
  @Output() readonly close = new EventEmitter<void>();
  /** A phone person's Cancel or Hang up (ITP-E-198-01), with their phone key. */
  @Output() readonly hangUpPhone = new EventEmitter<string>();

  get inCallCount(): number {
    return this.rows.filter(row => row.inCall).length;
  }

  /** Whether the header has a ×: only when someone is there to close it. */
  get closable(): boolean {
    return this.close.observed;
  }

  onClose(): void {
    this.close.emit();
  }

  onHangUpPhone(row: CallParticipantRow): void {
    if (row.phone) {
      this.hangUpPhone.emit(row.phone.key);
    }
  }

  trackByEmail(_: number, row: CallParticipantRow): string {
    return row.email;
  }
}
